import { Box, Container } from "@mui/material";
import Alert from "@mui/material/Alert";
import { useSearchParams } from "react-router";

import LoginButton from "@/components/LoginScreen/LoginButton";
import "@/components/LoginScreen/LoginScreen.css";

const LoginScreen = () => {
  const [searchParams] = useSearchParams();
  const error_description = searchParams.get("error_description");
  return (
    <>
      <Container className="loginscreen-mainContainer">
        <Box className="ada-login-screen">
          <img src="/images/ada_face_purple_360.png" alt="ada logo" />
          <Box className="loginscreen-buttonContainer">
            <LoginButton />
          </Box>
          {error_description && (
            <Alert className="login-screen-alert" severity="warning">
              {error_description}
            </Alert>
          )}
        </Box>
      </Container>
    </>
  );
};

export default LoginScreen;
